import { prop } from "../../decorators/property";

export type FieldName = "Category" | "KeyPhrase" | "Space" | "Text" | "Year" | "Court";

export class QueryComponentModel extends Backbone.AssociatedModel {

    @prop() public FieldName: string;
    @prop() public Fragment: string;
    @prop() public Resolution: string;
    @prop() public Type: number;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/query-component.ts